import { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { path } from '../../paths';
import { onBasePath } from '../../paths/onBasePath';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './Roles.translations.json';
import { NotFound } from '../NotFound';
import { RoleDirectory } from './RoleDirectory';
import { RoleBreadcrumbsData } from './RoleBreadcrumbs';
import { RoleDetails } from './RoleDetails';
import { RoleCreate } from './RoleCreate';
import { RoleEdit } from './RoleEdit';
import { RoleClone } from './RoleClone';

export const { addTranslations, useTranslation, Translation } =
  i18nNsFactory('roles-page');
addTranslations(translations);

export const ROLE_ROUTES = [
  {
    path: path.roleDirectory,
    renderBreadcrumb: () => (
      <Translation>{(t) => t('breadcrumb.roles')}</Translation>
    ),
    children: [
      {
        index: true,
        element: <RoleDirectory />,
      },
      {
        path: path.roleCreate,
        element: <RoleCreate />,
        renderBreadcrumb: () => (
          <Translation>{(t) => t('breadcrumb.role-create')}</Translation>
        ),
      },
      {
        path: path.roleDetails,
        element: <RoleDetails />,
        renderBreadcrumb: (data?: RoleBreadcrumbsData) =>
          data ? (
            data.name
          ) : (
            <Translation>{(t) => t('breadcrumb.role-detail')}</Translation>
          ),
      },
      {
        path: path.roleEdit,
        renderBreadcrumb: () => (
          <Translation>{(t) => t('breadcrumb.role-edit')}</Translation>
        ),
        element: <RoleEdit />,
      },
      {
        path: path.roleClone,
        element: <RoleClone />,
        renderBreadcrumb: () => (
          <Translation>{(t) => t('breadcrumb.role-clone')}</Translation>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export const Roles: FC<{ basePath: string }> = ({ basePath }) =>
  useRoutes(onBasePath(basePath, ROLE_ROUTES));
